import { GtmHelper, findApiV4Link, gaEvent } from 'shared'
import classNames from 'classnames'

export const DonateButton = (props) => {
  // Avoid href to be undefined
  const donateUrl = findApiV4Link({ ofObject: props.project, withRel: 'new_donation' }) || ''

  const tracking = (event) => {
    GtmHelper.pushAddToBasket(props.project)
    gaEvent('donation', props.gaAction)
  }

  if (props.status === 'blocked') {
    return <div className='generic-placeholder-box is-secondary'>
      {I18n.t('projects.show.stats.donate_button_blocked_explanation')}
    </div>
  }

  if (props.status === 'preparing') {
    return <div className='generic-placeholder-box'>
      {I18n.t('projects.show.stats.donate_button_placeholder')}
    </div>
  }

  if (props.status === 'closed' || props.project.progress_percentage >= 100) {
    return null
  }

  return <a
    className={classNames('btn', 'btn-primary', props.additionalClass, { 'duplication-icon matching-fund': props.active_matching_fund })}
    href={donateUrl}
    onClick={tracking}
  >
    {I18n.t('projects.show.stats.donate_button_label')}
  </a>
}
